var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotGroup)?_c('div',_vm._l((_vm.items),function(item,i){return _c('span',{key:'instalacion'+i},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }